import type { QueryResult } from '@apollo/react-hooks';
import { useQuery, gql } from '@apollo/react-hooks';
import { getAttachmentList } from '#/graphql/queries';
import type { GetAttachmentListQuery } from '#/graphql/types';

const q = gql(getAttachmentList);

export interface AttachmentsQueryVars {
  conditionObject?: Record<string, unknown>;
  conditionString?: string;
}

const useGetAttachmentsList = (vars: AttachmentsQueryVars = {}) => {
  const parsedVars = {
    ...vars,
    conditionObject: vars.conditionObject
      ? JSON.stringify(vars.conditionObject)
      : undefined,
  };

  const query: QueryResult<GetAttachmentListQuery> = useQuery(q, {
    variables: {
      params: {
        filter: vars.conditionString
      },
      filter: vars.conditionString
    },
  });

  return query;
};

export default useGetAttachmentsList;